import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { WebhookForm } from "../Forms/WebhookForm.tsx";

export const WebhookDrawer = () => {
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.Webhook} title={t("nodes.webhook.drawers.title")}>
            <WebhookForm formId={FormId.WebhookForm} />
        </BaseConnectionCreatorDrawer>
    );
};
